import { BaselineIcon } from 'canoe';
import React, { useCallback } from 'react';

import { ValueToggle } from '@candu-ai/craft/ui';

interface Props {
  alignItems?: string;
  alignSelf?: string;
  flexDirection?: string;
  toggleValues: (values: Record<string, unknown>) => void;
  isChild?: boolean;
}

export const AlignBaseline = ({
  alignItems,
  alignSelf,
  flexDirection,
  toggleValues,
  isChild,
}: Props) => {
  const onClick = useCallback(() => {
    if (isChild) {
      toggleValues({
        alignSelf: 'baseline',
      });
    } else {
      toggleValues({
        alignItems: 'baseline',
      });
    }
  }, [isChild, toggleValues]);

  return (
    <ValueToggle
      toggleGroup={isChild ? 'self-align' : 'flex-align-items'}
      id={isChild ? 'self-align-baseline' : 'align-baseline'}
      data-cy="toolbox-flex-align-baseline"
      onClick={onClick}
      isActive={isChild ? alignSelf === 'baseline' : alignItems === 'baseline'}
      icon={flexDirection === 'row' ? BaselineIcon : BaselineIcon}
      tooltip="Baseline"
      color="light"
    />
  );
};
